import './ConsentBox.scss';
import React, { useState } from 'react';
import { useTenant } from '../../context/TenantContext';
import ConsentModal from '../consetModal/ConsentModal';

const ConsentBox = ({ checked, onChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isMeliTenant } = useTenant();

  const handleBoxClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    if (checked && onChange) {
      onChange({
        target: {
          name: 'consentChecked',
          checked: false,
        },
      });
    }
  };

  const handleAcceptModal = () => {
    setIsModalOpen(false);
    if (!checked && onChange) {
      onChange({
        target: {
          name: 'consentChecked',
          checked: true,
        },
      });
    }
  };

  const handleToggleCheck = () => {
    if (onChange) {
      onChange({
        target: {
          name: 'consentChecked',
          checked: !checked,
        },
      });
    }
  };

  return (
    <>
      <div className={`consent-box ${isMeliTenant ? 'consent-box-meli' : ''}`}>
        <div className="consent-box-content">
          <div onClick={handleToggleCheck}>
            <input
              type="checkbox"
              id="redec-consent"
              className="consent-box-input"
              checked={checked}
              readOnly
            />

            <div className="consent-box-checkmark" />
          </div>

          <span className="consent-box-text">
            Autorizo expresamente a BK Servicios Financieros para que consulte mi información
            contenida en el{' '}
            <span className="consent-box-link" onClick={handleBoxClick}>
              Registro de Deuda Consolidada (REDEC)
            </span>
            , administrado por la CMF, para evaluar la solicitud de crédito conforme a la Ley Nº
            21.680.
          </span>
        </div>
      </div>

      <ConsentModal isOpen={isModalOpen} onClose={handleCloseModal} onAccept={handleAcceptModal} />
    </>
  );
};

export default ConsentBox;
